<script>
import { navComputed } from '@state/helpers'
import HrItemsGroup from '../safehaven/hr-items-group.vue'
import { exportService } from '@services/ExportService'

export default {
  components: {
    HrItemsGroup,
  },
  props: {
    // preselected group for using inside views (e.g Medical History should preselect its group)
    group: {
      type: Number,
      default: 0,
    },

    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      exportLoading: false,
      formSaved: false,
      formChanged: false,
      snackbar: false,
      snackbarMessage: '',
      selected: null,
      groupProp: null,
    }
  },
  computed: {
    ...navComputed,
    openRightSideDrawer() {
      return this.calendarDrawer || this.settingsDrawer
    },
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
    hrTypes() {
      return this.selected.map((el) => {
        return el.plain_resource
      })
    },
  },
  mounted() {
    this.groupProp = this.group
  },
  methods: {
    selectSection(event, item) {
      this.exportToPdf()
    },
    closeDialog() {
      this.$emit('update:dialog', false)
      setTimeout(() => {
        this.selected = null
      }, 500)
    },
    selectEvent(card) {
      this.selected = card
    },
    async exportToPdf() {
      try {
        this.exportLoading = true
        const { data } = await exportService.create({
          hr_types: this.hrTypes,
        })
        window.open(data)
      } catch (error) {
        console.warn(error)
      } finally {
        this.exportLoading = false
      }
    },
  },
}
</script>

<template>
  <v-container class="pa-0">
    <v-dialog
      :value="dialog"
      :fullscreen="mobile"
      persistent
      no-click-animation
      overlay-color="body"
      overlay-opacity="0.6"
      min-width="300px"
      max-width="850px"
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.dialogMenu"
    >
      <v-card color="#FFFFFF;" min-height="450">
        <v-card-text>
          <!-- close button -->
          <v-row class="pt-4" no-gutters justify="end">
            <v-btn color="offblack" icon @click="closeDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-row>

          <!-- card dialog -->
          <template>
            <!-- title, subtitle -->
            <v-row
              no-gutters
              class="px-10 offblack--text"
              :class="$style.dialogTitle"
            >
              What types of records would you like to export?
            </v-row>
            <!-- Hr select cards ( use key to rerender when dialog re-opens) -->
            <HrItemsGroup
              :key="dialog"
              multiple
              :group="groupProp"
              @select-changed="selectEvent"
            ></HrItemsGroup>

            <!-- submit button -->
            <v-row no-gutters align="center" justify="center">
              <v-btn
                :loading="exportLoading"
                :class="[
                  'primary-btn',
                  (!selected || !selected.length) && 'disabled-btn',
                ]"
                elevation="0"
                width="236"
                height="37"
                @click="selectSection($event, selected)"
                >Export</v-btn
              >
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.fabButton {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
}

.fabButtonOffset {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
  transform: translateX(-300px);
}

.dialogMenu {
  border-radius: 4px !important;

  /* width */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    margin-top: 5px;
    margin-bottom: 5px;
    background: $color-theme-light-input;
    border-radius: 15px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $color-theme-light-line;
    border-radius: 15px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $color-theme-light-placehold;
  }

  &::-webkit-scrollbar-thumb:active {
    background: $color-theme-light-label;
  }
}

.dialogTitle {
  display: block;
  font-size: 22px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 24px !important;
  color: #454648 !important;
  text-align: center;
}
</style>
